<script setup lang="ts">
import Block from "@/components/ui/atoms/Block.vue";
import BlockContainer from "@/components/ui/atoms/BlockContainer.vue";
import MasterBlock from "@/components/ui/atoms/MasterBlock.vue";
import type { Branch, Course } from "@/shared/explorerTypes";

interface Props {
  course: Course;
  currentBranch: Branch;
}

const props = defineProps<Props>();

const getImageUrl = (imageName) => {
  return new URL(
    `../../assets/img/${props.currentBranch.slug}_${imageName}.svg`,
    import.meta.url,
  ).href;
};
</script>

<template>
  <MasterBlock theme="smoke">
    <section class="container">
      <div class="container__header">
        <h2>¿QUE INCLUYE ESTE CURSO?</h2>
      </div>
      <div class="perks-container">
        <BlockContainer behaviour="stripes" theme="smoke" class="perks-container__row">
          <Block class="perk-item">
            <img :src="getImageUrl('foro')" alt="Acceso total" />
            <div class="perk-item__text">
              <h3 class="size-l">Ejercicios corregidos por profesores reales</h3>
              <p class="no-margins">
                Recibe retroalimentación real en cada ejercicio, revisado por nuestros
                expertos docentes.
              </p>
            </div>
          </Block>
          <Block class="perk-item">
            <img :src="getImageUrl('ejercicios')" alt="Acceso total" />
            <div class="perk-item__text">
              <h3 class="size-l">Resolvemos tus dudas en cada clase</h3>
              <p class="no-margins">
                Comparte tus dudas y obtén respuestas de nuestros expertos y de la
                comunidad Mastermind.
              </p>
            </div>
          </Block>
          <Block class="perk-item">
            <img :src="getImageUrl('actualizaciones')" alt="Acceso total" />
            <div class="perk-item__text">
              <h3 class="size-l">Actualizaciones Frecuentes de contenido</h3>
              <span class="no-margins">
                Revisamos y mejoramos el contenido de forma constante para estar al día.
              </span>
            </div>
          </Block>
        </BlockContainer>

        <BlockContainer behaviour="stripes" theme="smoke">
          <Block class="perk-item">
            <img :src="getImageUrl('reto-final')" alt="Acceso total" />
            <div class="perk-item__text">
              <h3>Reto Final: Tu Conocimiento en Acción</h3>
              <p class="no-margins">
                Demuestra lo que has aprendido con un proyecto original diseñado para
                retarte.
              </p>
            </div>
          </Block>
          <Block class="perk-item">
            <img :src="getImageUrl('certificado')" alt="Acceso total" />
            <div class="perk-item__text">
              <h3>Certificación para Impulsar tu CV</h3>
              <p class="no-margins">
                Completa el curso y entrega tus ejercicios para obtener un certificado que
                valida tu esfuerzo y aprendizaje.
              </p>
            </div>
          </Block>
        </BlockContainer>
      </div>
    </section>
  </MasterBlock>
</template>

<style scoped lang="scss">
@use "@/styles/settings/vars";

.perks-container {
  &__row {
    margin-bottom: 1em;
  }

  .perk-item {
    &__text {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex-grow: 1;

      span {
        margin-top: auto;
      }
    }

    img {
      max-width: 100%;
      margin: 0 auto 1em;
    }

    h3 {
      text-transform: uppercase;
    }
  }
}
</style>
